import { Mapper } from "../../../../base/utils/mapper";

import { PerfilMenuModel }
from "../../../../domain/models/configuration/perfil-menu.model";

import { PerfilMenuEntity }
from "../entities/perfil-menu.entity";

export class PerfilMenuImplementationRepositoryMapper
extends Mapper<
PerfilMenuEntity,
PerfilMenuModel
> {

    mapFrom(param:
    PerfilMenuEntity):
    PerfilMenuModel {

        return {
            ...param
        };
    }

    mapTo(param:
    PerfilMenuModel):
    PerfilMenuEntity {

        return {
            ...param
        };
    }
}